import { observable, action } from 'mobx';
import agent from '../agent'
// import authStore from './authStore'
// import gameStore from './gameStore'
import { $util } from '../helper'
import $const from '../helper/const'
class personGameStore {
  @observable info = {};
  //之前所有环节的技术方向
  @observable allDirections = [];
  //用户选择的技术方向
  @observable myDirection = undefined;
  //所选技术方向的id
  @observable selectDirectionId = undefined;
  //提交记录里
  @observable allDirectionUuid = undefined;
  // 面试预约的表单
  @observable meetingForm = undefined;
  @observable meetingFormCallback = undefined;
  @observable myEvents = [];
  @action resetInfo () {
    this.info = {}
  }
  @action getGameInfo (id) {
    return agent.Games.getApplicationById({
      variables: {
        id: id
      }
    }).then(action((res) => {
      if (res && res.data && res.data.registration) {
        this.info = res.data.registration
        if(this.info.commonInputs && this.info.commonInputs.nodes && this.info.event.flows && this.info.event.flows.nodes){
          //技术方向组件的uuid
          let _allDirectionUuid = [];
          //之前所有环节的技术方向的goptions
          let _allDirection = [];
          //当前流程的id
          let _currentFlowId = this.info.flowId;
          //当前流程为赛事的第几个流程,得出下标
          let _currentFlowIndex = null;
          _currentFlowIndex = this.info.event.flows.nodes.findIndex(item=>item.id === _currentFlowId);
          this.info.event.flows.nodes[_currentFlowIndex] && this.info.event.flows.nodes[_currentFlowIndex].stages.nodes.forEach(item=>{
            if(item && item.forms && item.forms.nodes && item.forms.nodes[0] && item.forms.nodes[0].formInputs && item.forms.nodes[0].formInputs.nodes){
              item.forms.nodes[0].formInputs.nodes.forEach(innerInput=>{
                if(innerInput.input.viewType === $const.INPUTVIEWTYPE.TECH_DIRECTION_SELECT && innerInput.goptions.nodes.length > 0){
                  innerInput.goptions.nodes.forEach(iiItem=>{
                    if(iiItem.valueString){
                      if(_allDirectionUuid.indexOf(innerInput.keyNameUuid) === -1) {
                        _allDirectionUuid.push(innerInput.keyNameUuid)
                      }
                      if(_allDirection.indexOf(innerInput.goptions) === -1) {
                        _allDirection.push(innerInput.goptions)
                      }
                    }
                  })
                  return true
                }   
              })
            }
          })
          this.allDirections = _allDirection;
          let _myDirection = null;
          this.info.commonInputs.nodes.forEach(item=>{
            _allDirectionUuid.forEach(iiItem=>{
              if(item.stringInputs.nodes.length > 0){
                item.stringInputs.nodes.forEach(innerItem=>{
                  if(innerItem.keyNameUuid === iiItem){
                    //可能有很多个用户提交的技术方向记录，这里默认记录最后一个记录
                    if(innerItem.value !== ''){
                      _myDirection = innerItem.value
                    }
                  }
                })
              }
            })
            
          });
          //用户最后一次提交的技术方向的值
          this.myDirection = _myDirection;
          let _selectItem = null;
          //根据用户提交的最后一次的技术方向的值找出对象的id
          this.allDirections.forEach(item=>{
            item.nodes.forEach(innerItem=>{
              if(innerItem.valueString === this.myDirection){
                _selectItem = innerItem
              }
            })
          })
          _selectItem && (this.selectDirectionId = _selectItem.id);
        }
        // 获取比赛流程
        this.info.myFlow = $util.getPersonFlow(this.info.event, this.info.flowId)
        this.info.myFlow.event = this.info.event
        this.info.myFlow.eventId = this.info.event && this.info.event.id
        // 比赛节点排序
        if (this.info.myFlow && this.info.myFlow.stages && this.info.myFlow.stages.nodes) {
          this.info.myFlow.stages.nodes = this.info.myFlow.stages.nodes.sort(function(a, b) {
            return (a.majorNum * 10 + (a.minorNum ? a.minorNum : 0)) - (b.majorNum * 10 + (b.minorNum ? b.minorNum : 0));
          })
          let length = this.info.myFlow.stages.nodes.length
          // 节点里的表单项排序
          for (let i = 0; i < length; i++) {
            if (this.info.myFlow.stages.nodes[i].forms && this.info.myFlow.stages.nodes[i].forms.nodes && this.info.myFlow.stages.nodes[i].forms.nodes[0]) {
              if (this.info.myFlow.stages.nodes[i].forms.nodes[0].formInputs && this.info.myFlow.stages.nodes[i].forms.nodes[0].formInputs.nodes) {
                this.info.myFlow.stages.nodes[i].forms.nodes[0].formInputs.nodes = this.info.myFlow.stages.nodes[i].forms.nodes[0].formInputs.nodes.sort(function(a, b) {
                  return a.orderNum - b.orderNum
                })
              }
            }
          }
        }
      }
      // 如果有比赛状态产生 梳理他的状态
      if (this.info.myFlow && this.info.registrationStageStatuses && this.info.registrationStageStatuses.nodes) {
        $util.formatStageStatus(this.info.myFlow.stages.nodes, this.info.registrationStageStatuses.nodes)
      }
      if (this.info.myFlow && this.info.myFlow.stages.nodes) {
        $util.formatMeeting(this.info.myFlow.stages.nodes, this.info.id)
      }
    }))
  }

  @action setMeetingForm (form, callBack) {
    this.meetingForm = form
    this.meetingFormCallback = callBack
  }

  @action submitMeetingForm () {
    return agent.Meetings.submit(this.meetingForm)
    .then(action((res) => {
      this.meetingFormCallback && this.meetingFormCallback()
    }))
  }

  @action getEvents () {
    return agent.Games.getMyApplications().then(action((res) => {
      if (res && res.data && res.data.member && res.data.member.registrations) {
        this.myEvents = res.data.member.registrations.nodes
      }
    })).finally()
  } 
}

export default new personGameStore();


// WEBPACK FOOTER //
// ./src/stores/personGameStore.js